/**
 * @flow
 * @relayHash 55b90774a62c4eac7cb4688fd93e2763
 */

/* eslint-disable */

'use strict';

/*::
import type { ConcreteRequest } from 'relay-runtime';
export type UpdateCompanyInput = {|
  timezone?: ?string,
  addressLine1?: ?string,
  addressLine2?: ?string,
  addressCity?: ?string,
  addressState?: ?string,
  addressZip?: ?string,
  addressCountry?: ?string,
  phone?: ?string,
  sundayHoursStart?: ?any,
  sundayHoursEnd?: ?any,
  mondayHoursStart?: ?any,
  mondayHoursEnd?: ?any,
  tuesdayHoursStart?: ?any,
  tuesdayHoursEnd?: ?any,
  wednesdayHoursStart?: ?any,
  wednesdayHoursEnd?: ?any,
  thursdayHoursStart?: ?any,
  thursdayHoursEnd?: ?any,
  fridayHoursStart?: ?any,
  fridayHoursEnd?: ?any,
  saturdayHoursStart?: ?any,
  saturdayHoursEnd?: ?any,
  autoEmailOnOrderCreated?: ?boolean,
  autoEmailOnInvoiceCreated?: ?boolean,
  autoEmailOnShipmentCreated?: ?boolean,
  currency?: ?string,
  pickMethod?: ?string,
  upsClientId?: ?string,
  upsClientSecret?: ?string,
  upsAccountNumber?: ?string,
  upsShipperName?: ?string,
  upsShipperPhone?: ?string,
  upsShipperAddressLine1?: ?string,
  upsShipperAddressLine2?: ?string,
  upsShipperAddressCity?: ?string,
  upsShipperAddressState?: ?string,
  upsShipperAddressZip?: ?string,
  upsShipperAddressCountry?: ?string,
|};
export type UpdateCompanyMutationVariables = {|
  input: UpdateCompanyInput
|};
export type UpdateCompanyMutationResponse = {|
  +updateCompany: {|
    +company: {|
      +id: string,
      +name: ?string,
      +namespace: string,
      +timezone: ?string,
      +addressLine1: ?string,
      +addressLine2: ?string,
      +addressCity: ?string,
      +addressState: ?string,
      +addressZip: ?string,
      +addressCountry: ?string,
      +phone: ?string,
      +sundayHoursStart: ?string,
      +sundayHoursEnd: ?string,
      +mondayHoursStart: ?string,
      +mondayHoursEnd: ?string,
      +tuesdayHoursStart: ?string,
      +tuesdayHoursEnd: ?string,
      +wednesdayHoursStart: ?string,
      +wednesdayHoursEnd: ?string,
      +thursdayHoursStart: ?string,
      +thursdayHoursEnd: ?string,
      +fridayHoursStart: ?string,
      +fridayHoursEnd: ?string,
      +saturdayHoursStart: ?string,
      +saturdayHoursEnd: ?string,
      +currency: string,
      +pickMethod: string,
      +autoEmailOnOrderCreated: boolean,
      +autoEmailOnInvoiceCreated: boolean,
      +autoEmailOnShipmentCreated: boolean,
      +upsClientId: ?string,
      +upsClientSecret: ?string,
      +upsAccountNumber: ?string,
      +upsShipperName: ?string,
      +upsShipperPhone: ?string,
      +upsShipperAddressLine1: ?string,
      +upsShipperAddressLine2: ?string,
      +upsShipperAddressCity: ?string,
      +upsShipperAddressState: ?string,
      +upsShipperAddressZip: ?string,
      +upsShipperAddressCountry: ?string,
      +calendarEvents: $ReadOnlyArray<{|
        +id: string,
        +name: string,
        +isFullDay: boolean,
        +isOpen: boolean,
        +startAt: any,
        +endAt: any,
      |}>,
    |}
  |}
|};
export type UpdateCompanyMutation = {|
  variables: UpdateCompanyMutationVariables,
  response: UpdateCompanyMutationResponse,
|};
*/


/*
mutation UpdateCompanyMutation(
  $input: UpdateCompanyInput!
) {
  updateCompany(input: $input) {
    company {
      id
      name
      namespace
      timezone
      addressLine1
      addressLine2
      addressCity
      addressState
      addressZip
      addressCountry
      phone
      sundayHoursStart
      sundayHoursEnd
      mondayHoursStart
      mondayHoursEnd
      tuesdayHoursStart
      tuesdayHoursEnd
      wednesdayHoursStart
      wednesdayHoursEnd
      thursdayHoursStart
      thursdayHoursEnd
      fridayHoursStart
      fridayHoursEnd
      saturdayHoursStart
      saturdayHoursEnd
      currency
      pickMethod
      autoEmailOnOrderCreated
      autoEmailOnInvoiceCreated
      autoEmailOnShipmentCreated
      upsClientId
      upsClientSecret
      upsAccountNumber
      upsShipperName
      upsShipperPhone
      upsShipperAddressLine1
      upsShipperAddressLine2
      upsShipperAddressCity
      upsShipperAddressState
      upsShipperAddressZip
      upsShipperAddressCountry
      calendarEvents {
        id
        name
        isFullDay
        isOpen
        startAt
        endAt
      }
    }
  }
}
*/

const node/*: ConcreteRequest*/ = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "input",
    "type": "UpdateCompanyInput!",
    "defaultValue": null
  }
],
v1 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v3 = [
  {
    "kind": "LinkedField",
    "alias": null,
    "name": "updateCompany",
    "storageKey": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateCompanyPayload",
    "plural": false,
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "company",
        "storageKey": null,
        "args": null,
        "concreteType": "Company",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "namespace",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "timezone",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "addressLine1",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "addressLine2",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "addressCity",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "addressState",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "addressZip",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "addressCountry",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "phone",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "sundayHoursStart",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "sundayHoursEnd",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "mondayHoursStart",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "mondayHoursEnd",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "tuesdayHoursStart",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "tuesdayHoursEnd",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "wednesdayHoursStart",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "wednesdayHoursEnd",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "thursdayHoursStart",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "thursdayHoursEnd",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "fridayHoursStart",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "fridayHoursEnd",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "saturdayHoursStart",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "saturdayHoursEnd",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "currency",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "pickMethod",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "autoEmailOnOrderCreated",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "autoEmailOnInvoiceCreated",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "autoEmailOnShipmentCreated",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "upsClientId",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "upsClientSecret",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "upsAccountNumber",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "upsShipperName",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "upsShipperPhone",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "upsShipperAddressLine1",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "upsShipperAddressLine2",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "upsShipperAddressCity",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "upsShipperAddressState",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "upsShipperAddressZip",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "ScalarField",
            "alias": null,
            "name": "upsShipperAddressCountry",
            "args": null,
            "storageKey": null
          },
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "calendarEvents",
            "storageKey": null,
            "args": null,
            "concreteType": "CompanyCalendarEvent",
            "plural": true,
            "selections": [
              (v1/*: any*/),
              (v2/*: any*/),
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "isFullDay",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "isOpen",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "startAt",
                "args": null,
                "storageKey": null
              },
              {
                "kind": "ScalarField",
                "alias": null,
                "name": "endAt",
                "args": null,
                "storageKey": null
              }
            ]
          }
        ]
      }
    ]
  }
];
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "UpdateCompanyMutation",
    "type": "Mutation",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v3/*: any*/)
  },
  "operation": {
    "kind": "Operation",
    "name": "UpdateCompanyMutation",
    "argumentDefinitions": (v0/*: any*/),
    "selections": (v3/*: any*/)
  },
  "params": {
    "operationKind": "mutation",
    "name": "UpdateCompanyMutation",
    "id": null,
    "text": "mutation UpdateCompanyMutation(\n  $input: UpdateCompanyInput!\n) {\n  updateCompany(input: $input) {\n    company {\n      id\n      name\n      namespace\n      timezone\n      addressLine1\n      addressLine2\n      addressCity\n      addressState\n      addressZip\n      addressCountry\n      phone\n      sundayHoursStart\n      sundayHoursEnd\n      mondayHoursStart\n      mondayHoursEnd\n      tuesdayHoursStart\n      tuesdayHoursEnd\n      wednesdayHoursStart\n      wednesdayHoursEnd\n      thursdayHoursStart\n      thursdayHoursEnd\n      fridayHoursStart\n      fridayHoursEnd\n      saturdayHoursStart\n      saturdayHoursEnd\n      currency\n      pickMethod\n      autoEmailOnOrderCreated\n      autoEmailOnInvoiceCreated\n      autoEmailOnShipmentCreated\n      upsClientId\n      upsClientSecret\n      upsAccountNumber\n      upsShipperName\n      upsShipperPhone\n      upsShipperAddressLine1\n      upsShipperAddressLine2\n      upsShipperAddressCity\n      upsShipperAddressState\n      upsShipperAddressZip\n      upsShipperAddressCountry\n      calendarEvents {\n        id\n        name\n        isFullDay\n        isOpen\n        startAt\n        endAt\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
// prettier-ignore
(node/*: any*/).hash = '675973e83a26ff3ab153c3120c73b184';
module.exports = node;
